import {useDesignServiceState} from "../../../../hooks/useDesignServiceState";
import {Collapse, Form} from "react-bootstrap";
import * as React from "react";

interface IProps { 
    location: string,
}

export const DesignServices = ({location}: IProps) => {
    const {
        model: {
            price,
            smallScreenSize,
            checked,
            breakOutEarly,
            onChange,
        },
 
    } = useDesignServiceState();


    if (breakOutEarly) return <></>;

    return (
        <>
            <Form.Group className="pb-2 px-0 mb-2">
                <Form.Check
                    className="design-services-check mb-0"
                    type="checkbox"
                    id={`design-services-check-${location}`}
                    aria-expanded={checked}
                    aria-controls="design-services-info"
                    label={
                        <>
                            <strong className="d-block design-services-title">Add Design Services <span
                                className="fw-normal">({price} per hour)</span></strong>

                        </>
                    }
                    checked={checked}
                    onChange={onChange}
                />
                <Collapse in={smallScreenSize ? checked : true}>
                    <div id={`design-services-text-${location}`}className="text-muted ms-4">
                        <small>
                            Expect your dedicated design team to contact you within 24 hours to bring your vision to
                            life
                            starting with 1-hour of design services. <a href='/designservice' className=""
                                                                        target="_blank" tabIndex={0} role="link" aria-label="Go to view more information about design services.">About
                            Design Services</a>

                        </small>
                    </div>
                </Collapse>
            </Form.Group>

        </>
    );
};